import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://appointments-qa-api.bioreference.com',
  apiKey: 'AIzaSyBuQxdhirGS8F9NRhkG9-SiospyLJJ_v2M',
  mapId: 'e78d706076e3ea13931a4d71'
};
